import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import ChangeDialog from '@auteco/components/insigthFactory/changesDialog/ChangeDialog';
import EmptyMessage from '../../../components/insigthFactory/emptyMessage/EmptyMessage';
import TableInsights from '../../../components/sharedComponents/Tablas/TableInsights/TableInsights';
import ReturnButton from '../ReturnButton';

const Changes = (props) => {
  const {
    units,
    result,
    openResult,
    historyList,
    onOpenResult,
    onCloseResult,
    onAcceptChange,
    onRejectChange,
    onClickReturn
  } = props;

  const columns = [
    { title: 'ID', field: 'id', hidden: true },
    { title: 'NOMBRE', field: 'usuario.nombre' },
    { title: 'APELLIDO', field: 'usuario.apellido' },
    { title: 'CORREO', field: 'usuario.correo' },
    { title: 'TITULO INSIGHT', field: 'entrada_actual.titulo' },
    {
      title: 'UNIDAD DE NEGOCIO',
      field: 'entrada_sistema.id_unidad_negocio',
      render: (rowData) => {
        const unidadNegocio = units
          .filter((unit) => unit.id === rowData.entrada_actual.id_unidad_negocio).pop();
        return (<td>{`${unidadNegocio?.unidad}`}</td>);
      },
    },
    {
      title: 'FECHA',
      render: (rowData) => <td>{`${rowData.fecha_creacion?.slice(0, 10)}`}</td>,
    },
  ];

  return (
    <>
      <ReturnButton label='Volver' onClick={onClickReturn} />
      {historyList.length === 0 ? (
        <EmptyMessage title="No hay cambios pendientes por aceptar" />
      ) : (
        <>
          <CardTitle title="Aceptar Cambios en los insights" />
          <ChangeDialog
            openResult={openResult}
            onCloseResult={onCloseResult}
            result={result}
          />
          <TableInsights
            title="Lista de Cambios"
            dataTable={historyList}
            hiddenEdit
            columns={columns}
            onRejectTest={onRejectChange}
            onAcceptTest={onAcceptChange}
            onOpenView={onOpenResult}
          />
        </>
      )}
    </>
  );
};

export default Changes;
